import React from "react";
import { Form } from "react-bootstrap";
import { FormikErrors, FormikHandlers, FormikTouched } from "formik";

interface BusinessNameFormValues {
  businessName: string;
  confirmBusinessName: string;
}

interface BusinessNameFormProps {
  handleChange: FormikHandlers["handleChange"];
  handleBlur: FormikHandlers["handleBlur"];
  values: BusinessNameFormValues;
  touched: FormikTouched<BusinessNameFormValues>;
  errors: FormikErrors<BusinessNameFormValues>;
}

const BusinessNameForm = ({
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
}: BusinessNameFormProps) => {
  return (
    <>
      <Form.Group className="mb-3" controlId="formBusinessNameField">
        <Form.Label>New Business Name</Form.Label>
        <Form.Control
          name="businessName"
          placeholder="Business Legal Name"
          value={values.businessName}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.businessName && !!errors.businessName}
          isValid={touched.businessName && !errors.businessName}
        />
        <Form.Control.Feedback type="invalid">
          {errors.businessName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formConfirmBusinessNameField">
        <Form.Label>Confirm Business Name</Form.Label>
        <Form.Control
          name="confirmBusinessName"
          placeholder="Business Legal Name"
          value={values.confirmBusinessName}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={
            touched.confirmBusinessName && !!errors.confirmBusinessName
          }
          isValid={touched.confirmBusinessName && !errors.confirmBusinessName}
        />
        <Form.Control.Feedback type="invalid">
          {errors.confirmBusinessName}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default BusinessNameForm;
